import {fetchDataFromApi} from './apiHelper';

export const fetchFields = () => fetchDataFromApi('post', '/api/smarthub/blockedcrids/fields');
export const fetchDspList = () => fetchDataFromApi('post', '/api/smarthub/blockedcrids/dsp');
export const fetchSspList = () => fetchDataFromApi('post', '/api/smarthub/blockedcrids/ssp');
